import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/i18n";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

// Langues disponibles (ordre du cycle). L'arabe est la seule en RTL.
export const LANGS = ["fr", "ar", "en"];
export const LANG_LABELS = { fr: "Français", ar: "العربية", en: "English" };
export const LANG_SHORT = { fr: "FR", ar: "ع", en: "EN" };

export function AppProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("lang");
    return LANGS.includes(saved) ? saved : "fr";
  });
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    if (theme === "dark") document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  // La sauvegarde de la langue sur le compte est gérée par AuthContext
  // (la session vit dans un cookie httpOnly, plus de jeton lisible ici).
  const value = useMemo(() => {
    const t = (key) => translations[lang]?.[key] ?? translations.fr[key] ?? key;
    const setLang = (l) => setLangState(l);
    const cycleLang = () => setLangState((cur) => LANGS[(LANGS.indexOf(cur) + 1) % LANGS.length]);
    const toggleTheme = () => setTheme((th) => (th === "light" ? "dark" : "light"));
    return { lang, setLang, cycleLang, theme, toggleTheme, t, isRTL: lang === "ar" };
  }, [lang, theme]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
